<template>
    <div class="row">
        <div class="col col-12 d-flex justify-content-center">
            <img data-aos="fade-right" data-aos-duration="1200" data-aos-delay="1000" src="../../public/images/next-hero.png" alt="">
        </div>
        <div class="col col-12 d-flex justify-content-center">
            <p data-aos="fade-left" data-aos-duration="1200" 
            data-aos-delay="1000" data-aos-anchor-placement="top-bottom"
            class="title">Here's my CV if you want to read about me</p>
        </div>
        <div class="col col-12 d-flex justify-content-center">
            <button data-aos="fade-left" data-aos-duration="1200" 
            data-aos-delay="1000" data-aos-anchor-placement="top-bottom"
            class="btn btn-outline-primary btn-md align-middle"> 
            <a href="https://drive.google.com/file/d/1TrJLBpF34jjUnysRZ14iLq9bxuJO0IcD/view?usp=share_link">My CV <b-icon-arrow-bar-right></b-icon-arrow-bar-right></a>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Cv'
}
</script>

<style lang="scss" scoped>
.row {
    width: 100%;
    margin: 0;
    padding: 2%;
    .col {
        width: 100%;
        margin: 0;
        padding: 0;
    }
    img {
        width: 20%;
        margin-bottom: 2%;
        @media (max-width: 767.8px) {
            width: 25%;
        }
    }
    button {
        font-family: 'Roboto', sans-serif !important;
        margin-bottom: 5%;
        a {
            text-decoration: none;
        }
    }
    button:hover {
        a{
            color: snow;
        }
    }
    @media (max-width: 767.8px) {
        margin-top: 5%;
    }
    @media (max-width: 350px) {
        height: 300px;
        margin-top: 5%;
        .title {
            font-size: 0.7rem !important;
        }
        img {
            width: 25%;
        }
    }
    @media (max-width: 250px) {
        height: 300px;
        margin-top: 5%;
        img {
            width: 25%;
        }
    }
}
</style>
